import React, { useEffect, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";

import { useropen } from '../redux/userInfo';


import { useDispatch, useSelector } from "react-redux";
import Profiles from './Profiles';
import { getMemberinfo } from "../utils/utils";

export default function MypageleftArea(props) {

    const { 
        pages='',
    } = props;


    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [memberinfos, setmemberinfos] = useState(''); 

    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);

    useEffect(() => {
        console.log("memberinfos", memberinfos);
    }, [memberinfos]);

    return (
        <div>
            <div className='padding40'>
                {memberinfos && <Profiles profileimgs={true} mypages={true} memberinfosData={memberinfos} />}
            </div>
            <button className='mypagelinks' onClick={() => { navigate('/Mypage'); }}>
                <div>
                    <img src={`./images/icons/${pages === 0 ? 'user-fill' : 'user'}.svg`} /> 
                    <span className={`${pages === 0 ? 'bolds color6164A5' : ''}`}>개인설정</span>
                </div>
                <img src={`./images/icons/chevron-right.svg`} /> 
            </button>
            {memberinfos?.level*1 === 3 &&
            <button 
                className='mypagelinks'
                onClick={() => {
                    navigate('/CompanyNotice');
                }}                     
            >
                <div>
                    <img src={`./images/icons/${pages === 1 ? 'building-4-line' : 'building-4-line-gray'}.svg`} /> 
                    <span className={`${pages === 1 ? 'bolds color6164A5' : ''}`}>사무소관리</span>
                </div>
                <img src={`./images/icons/chevron-right.svg`} /> 
            </button>
            }
            {memberinfos?.level*1 === 3 &&
            <button 
                className='mypagelinks'
                onClick={() => {
                    navigate('/Membercontrol');
                }}                   
            >
                <div>
                    <img src={`./images/icons/${pages === 2 ? 'group-fill' : 'group-line'}.svg`} /> 
                    <span className={`${pages === 2 ? 'bolds color6164A5' : ''}`}>직원관리</span>
                </div>
                <img src={`./images/icons/chevron-right.svg`} /> 
            </button>
            }
            <button 
                className='mypagelinks'
                onClick={() => {
                    navigate('/Workstat');
                }}                   
            >
                <div>
                    <img src={`./images/icons/${pages === 7 ? 'stats-dots-fill' : 'stats-dots-line'}.svg`} /> 
                    <span className={`${pages === 7 ? 'bolds color6164A5' : ''}`}>업무 통계</span>
                </div>
                <img src={`./images/icons/chevron-right.svg`} /> 
            </button>
            
            <button 
                className='mypagelinks'
                onClick={() => {
                    navigate('/Setoutside');
                    //navigate('/Setminihome');
                    
                }}                   
            >
                <div>
                    <img src={`./images/icons/${pages === 6 ? 'store-2-fill' : 'store-2-line'}.svg`} /> 
                    <span className={`${pages === 6 ? 'bolds color6164A5' : ''}`}>외부 광고 설정</span>
                </div>
                <img src={`./images/icons/chevron-right.svg`} /> 
            </button>
            {memberinfos?.level*1 === 3 &&
            <button 
                className='mypagelinks'
                onClick={() => {
                    navigate('/ApplicationList');
                }}                
            >
                <div>
                    <img src={`./images/icons/${pages === 3 ? 'draft-line-fill' : 'draft-line'}.svg`} /> 
                    <span className={`${pages === 3 ? 'bolds color6164A5' : ''}`}>소속신청관리</span>
                </div>
                <img src={`./images/icons/chevron-right.svg`} /> 
            </button>
            }
            <button 
                className='mypagelinks'
                onClick={() => {
                    navigate('/Deletelist');
                }}                  
            >
                <div>
                    <img src={`./images/icons/${pages === 4 ? 'delete-bin-fill' : 'delete-bin-line'}.svg`} /> 
                    <span className={`${pages === 4 ? 'bolds color6164A5' : ''}`}>삭제된매물</span>
                </div>
                <img src={`./images/icons/chevron-right.svg`} /> 
            </button>
            <button 
                className='mypagelinks'
                onClick={() => {
                    navigate('/Contactus');
                }}                  
            >
                <div>
                    <img src={`./images/icons/${pages === 5 ? 'questionnaire-fill' : 'questionnaire-line'}.svg`} /> 
                    <span className={`${pages === 5 ? 'bolds color6164A5' : ''}`}>문의하기</span>
                </div>
                <img src={`./images/icons/chevron-right.svg`} /> 
            </button>
            <div style={{ textAlign: 'center', padding: 20 }}>
                <button type='button'
                    onClick={() => {
                        dispatch(
                            useropen({
                                userdata: ""
                            })
                        );      
                        localStorage.setItem('token', '');
                        navigate('/');                     
                    }}
                >
                    로그아웃
                </button>
            </div>
        </div>
    )    
}